import * as React from 'react';
import { cx } from './util';
import styles from "./main.module.scss";
import { translateService, Translate } from '../../services/TranslateService';
import {useEffect, useRef, useState} from 'react';
import{CustomerCheckboxInput, CustomerTextInput,
  CountrySelect} from '../CustomerInput/CustomerInput';
import {
  useValidCompanyName, useValidCompanyId, useValidGivenName, useValidFamilyName,
  useValidCompanyRef, useIsCompany, useIsCountryForeign, useValidPhoneNumber,
  useValidEmail, useValidForeignCountryName, useValidZipCode,
  useValidCity, useValidAddress, useValidSocialSecurityNum, useValidDateOfBirth,
  checkBirthdateFromLogin} from '../../hooks/useCustomerHooks';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useDispatch, useSelector} from "react-redux";
import {GlobalStore} from "../../reduxStore";
import { DataContext } from '../../contexts/dataContext';
import {useClarityStep} from "../../services/clarity/useClarityStep";
import { BirthdayModalPicker } from '../CustomerInput/BirthdatePicker';
import ApiService from "../../services/api/ApiService";
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'; // TODO: re-enable when BE reCaptcha is ready
// import {ReCaptchaDisclaimer} from "../reCaptchaDisclaimer"; // TODO: re-enable when BE reCaptcha is ready

interface PropsInterface {
  back: Function;
  next: Function;
  setShowLogin: any;
  openSafeDriveInfo: Function;
  apiService: ApiService | undefined;
}

export default function CustomerInfo({ setShowLogin,back, next, openSafeDriveInfo, apiService}: PropsInterface) {
  const version = import.meta.env.VITE_VERSION;
  const [formSubmitted, setFormSubmitted] = useState(false);

  const {user, customer, services, changeCustomer, changeUser, sendGa4Event, noUnderTwentyOne, mobileDevice, changeVirtualPageInfo,
    searchParameters, oneWayRes, changeAddSafeDrivePackage, addSafeDrivePackage, appContext } = React.useContext(DataContext)
  const [isCustomerLoggedIn, setIsCustomerLoggedIn] = React.useState<boolean>(!!(customer?.loggedIn && checkBirthdateFromLogin(user?.birthDate)));
  const {isCompany, setIsCompany, isCompanyErrorString} = useIsCompany(!!user?.company?.name?.length);
  const {isCountryForeign, setIsCountryForeign, isCountryForeignErrorString } = useIsCountryForeign(!!user?.country);
  const {companyName, setCompanyName, companyNameErrorString, setCompanyNameErrorOverride, handleCompanyNameFieldErr,
    companyNameFieldRef} = useValidCompanyName(user?.company?.name || '', "companyNameField");
  const {companyId, setCompanyId, companyIdErrorString, setCompanyIdErrorOverride, handleCompanyIdFieldErr,
    companyIdFieldRef, setCompanyIdErrorString} = useValidCompanyId(user?.company?.vatNumber || '', "companyIdField");
  const {companyRef, setCompanyRef, companyRefErrorString, setCompanyRefErrorOverride} = useValidCompanyRef(user?.company?.reference || '');
  const {givenName, setGivenName, givenNameErrorString, handleGivenNameFieldErr, givenNameFieldRef} =
      useValidGivenName(user?.givenName || '', "givenNameField");
  const {familyName, setFamilyName, familyNameErrorString, handleFamilyNameFieldErr,familyNameFieldRef} =
      useValidFamilyName(user?.familyName || '', "familyNameField");
  const {phoneNumber, reEnterPhone, setPhoneNumber, phoneNumberErrorString, setReEnterPhone, reEnterPhoneErrorString,
    handlePhoneNumFieldErr, phoneNum1FieldRef, phoneNum2FieldRef } = useValidPhoneNumber(user?.phoneNumber || '',
      "phoneNumField1","phoneNumField2", !user?.id ? (customer?.phoneNumber2 || '') : user?.phoneNumber || '', services?.addDriverNumber ?? '');
  const {email, reEnterEmail, setEmail, emailErrorString, reEnterEmailErrorString, setReEnterEmail, handleEmailFieldErr,
    email1FieldRef, email2FieldRef } = useValidEmail(user?.email || "", "emailField1", "emailField2", customer?.email2 || '');
  const {dateOfBirth, setDateOfBirth, dateOfBirthErrorString, setDateOfBirthErrorOverride, handleDateOfBirthFieldErr,
    dateOfBirthFieldRef } = useValidDateOfBirth(user?.birthDate || user?.birthday || '', "dateOfBirthField",
      noUnderTwentyOne);
  const [modalOpen, setModalOpen] = React.useState(false);
  const {socialSecurityNum, setSocialSecurityNum, socialSecurityNumErrorString, setSocialSecurityNumErrorOverride,
    handleSSNFieldErr, SSNFieldRef } = useValidSocialSecurityNum(customer?.personalIdCode || '',
      isCustomerLoggedIn, "socialSecurityField", noUnderTwentyOne,
      (!isCountryForeign && !user?.birthDate), user?.birthDate);
  const {foreignCountry, setForeignCountry, foreignCountryErrorString, setForeignCountryErrorOverride,
    handleCountryFieldErr, countryFieldRef} = useValidForeignCountryName(user?.country ?? '', "countryField");
  const {address, setAddress, addressErrorString, handleAddressFieldErr, addressFieldRef} = useValidAddress(user?.address || '', "street-address",
      !!((foreignCountry?.toUpperCase() !== 'FINLAND' && isCountryForeign) || customer?.registeredForeigner)); // add Finland as it is an opton from dropdown
  const {city, setCity, cityErrorString, handleCityFieldErr, cityFieldRef} = useValidCity(user?.municipality || '', "address-level2");
  const {zipCode, setZipCode, zipCodeErrorString, handleZipCodeFieldErr, zipCodeFieldRef} = useValidZipCode(user?.postalCode || '', "postal-code",
      (foreignCountry?.toUpperCase() !== 'FINLAND' && isCountryForeign) || customer?.registeredForeigner);
  const [privateNum, setPrivateNum] = useState(false); // note: private + prepaid can both be selected (this is an and/or case)
  const [prepaidNum, setPrepaidNum] = useState(false);
  const [showCustomerForm, setShowCustomerForm] = useState<boolean>(!!((isCustomerLoggedIn || user?.id) && !(sessionStorage.getItem('closeNewCustomerInfo') ?? undefined)));
  const dispatch = useDispatch();
  const language = useSelector((deviceLang: GlobalStore) => deviceLang.chauffeurReducer.deviceLanguage);
  const [ submitValidationErrorString, setSubmitValidationErrorString ] = useState('');
  const [ saveInfoBtnClicked, setSaveInfoBtnClicked ] = useState(false);
  const [ firstRenderComplete, setFirstRenderComplete ] = useState<boolean>(false);
  const isFormUpdate = useRef(false); // tracks when customer update came from form input, not login
  const [ closeNewCustomerInfo, setCloseNewCustomerInfo ] = useState( sessionStorage.getItem('closeNewCustomerInfo') ?? undefined);
  const resetData = sessionStorage.getItem('resetCustomerData') ?? undefined;
  const hideNumberForUrlLogin = sessionStorage.getItem('AH-L') ?? undefined;
  // const { executeRecaptcha } = useGoogleReCaptcha(); // TODO: re-enable when BE reCaptcha is ready

  useClarityStep('customerInfo', {
    city: searchParameters?.location?.formatted_address || searchParameters?.pickupCity || '',
    start: searchParameters?.startDate?.toString() || '',
    end: searchParameters?.endDate?.toString() || '',
    oneway: oneWayRes,
    loggedIn: isCustomerLoggedIn ?? undefined,
    safeDrive: addSafeDrivePackage ?? false
  });

  useEffect(() => {
    changeVirtualPageInfo('customerInfo');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (resetData) {
      ResetCustomerData();
      sessionStorage.removeItem('resetCustomerData');
    }
  }, [resetData]);

  const ResetCustomerData = () => {
    setIsCompany(false);
    setIsCountryForeign(false);
    setCompanyName('');
    setCompanyId('');
    setCompanyRef('');
    setGivenName('');
    setFamilyName('');
    setPhoneNumber('');
    setReEnterPhone('');
    setEmail('');
    setReEnterEmail('');
    setDateOfBirth('');
    setSocialSecurityNum('');
    setForeignCountry('');
    setAddress('');
    setCity('');
    setZipCode('');
    setPrivateNum(false);
    setPrepaidNum(false);
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('AH-L');

    try {
      // Prevent calling replaceState repeatedly across renders or other triggers
      if (sessionStorage.getItem('urlParamsRemoved') === '1') return;

      const url = new URL(window.location.href);
      const paramsToRemove = ['hash', 'id', 'useCompany'];
      const hasParams = paramsToRemove.some(param => url.searchParams.has(param));
      if (hasParams) {
        paramsToRemove.forEach(param => url.searchParams.delete(param));
        window.history.replaceState({}, document.title, url.toString());
        // mark that we've removed params so we don't call replaceState again
        sessionStorage.setItem('urlParamsRemoved', '1');
      }
    } catch (e) {
      if (import.meta.env.MODE !== 'production') {
        console.warn('Could not call history.replaceState:', e);
      }
    }
  }

  useEffect(() => {
    setCompanyNameErrorOverride(!isCompany);
    setCompanyIdErrorOverride(!isCompany);
    setCompanyRefErrorOverride(!isCompany);

    if(!isCompany) { // clear out existing strings if company option is disabled, allows for customer update on BE
      if(companyName.length) {setCompanyName('')}
      if(companyId.length) {setCompanyId('')}
      if (companyRef.length) {setCompanyRef('')}
    }

  }, [isCompany]);

  useEffect(() => {
    setDateOfBirthErrorOverride(!isCountryForeign || (user?.id && checkBirthdateFromLogin(user?.birthDate)) ? true : false); // BIRTHDATE
    setSocialSecurityNumErrorOverride(isCountryForeign); // SSN
    setForeignCountryErrorOverride(!isCountryForeign); // COUNTRY NAME NEEDED

    // if switch to foreign - SSN must be empty and vice versa, else there will be a data conflict
    if (isCountryForeign) {
      if(socialSecurityNum) {setSocialSecurityNum('')}
    } else {
      if(foreignCountry) {setForeignCountry('')}
      if(dateOfBirth) {setDateOfBirth('')}
    }
  }, [isCountryForeign]);

  useEffect(() => {
    if (isCustomerLoggedIn) return;

    // update safe drive based on form changes when not logged in
    if (isCountryForeign && !services?.addSafeDrivePackage) {
      changeAddSafeDrivePackage(true);
    } else {
      changeAddSafeDrivePackage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCountryForeign, services, isCustomerLoggedIn]);

  useEffect(() => {
    if (customer === undefined) {
      customerValuesUpdate();
      return;
    }

    // skip when customer update came from form input (avoids re-render loop)
    if (isFormUpdate.current) {
      isFormUpdate.current = false;
      return;
    }

    if (customer) { // sets field data when existing customer logs in
      if (customer.companyName || customer.companyVatNumber || customer.companyReference) {
        setIsCompany(true);
        if (customer.companyName) {setCompanyName(customer.companyName)}
        if (customer.companyVatNumber) {setCompanyId(customer.companyVatNumber)}
        if (customer.companyReference) {setCompanyRef(customer.companyReference)}}
      if (customer.givenName) {setGivenName(customer.givenName)}
      if (customer.familyName) {setFamilyName(customer.familyName)}
      if (customer.phoneNumber) {setPhoneNumber(customer.phoneNumber)}
      if (customer.email) {setEmail(customer.email)}
      if (customer.loggedIn) {
        if(!isCustomerLoggedIn) {setIsCustomerLoggedIn(true)}
        setReEnterEmail(customer.email);
        setReEnterPhone(customer.phoneNumber);
        setDateOfBirthErrorOverride(true)
      } else if ((customer?.loggedIn && user?.id) || user?.smsLogin) { // if birthdate incorrect case, phone number still cannot be edited
        // re enter field should only set as original number if reenter field cannot be seen (or moving between screens after login)
        setReEnterPhone(customer.phoneNumber);
      }
      if ((customer.registeredForeigner || customer.unregisteredForeigner) ) {
        setIsCountryForeign(true);
        if (customer.dateOfBirth) {setDateOfBirth(customer.dateOfBirth)}
        if (customer.country) { setForeignCountry(customer.country) }
      } else {
        if (customer.personalIdCode) {setSocialSecurityNum(customer.personalIdCode)}
        if (isCountryForeign && customer.personalIdCode) {setIsCountryForeign(false)} // resets foreign country checkbox if checked before login
      }
      if (customer.address) {setAddress(customer.address)}
      if (customer.municipality) {setCity(customer.municipality)}
      if (customer.postalCode) {setZipCode(customer.postalCode)}
      if (customer.prepaid) {setPrepaidNum(customer.prepaid)}
      if (customer.secret) {setPrepaidNum(customer.secret)}
    }

  }, [customer]);

  const UpdateUser = (triggerSaveToCustomer: boolean, isCountryForeignChecked: boolean) => {
    changeUser({
      ...user,
      givenName: givenName,
      familyName: familyName,
      address: address,
      postalCode: zipCode,
      email: email,
      country: foreignCountry,
      birthday: dateOfBirth,
      phoneNumber: phoneNumber,
      personal_id_code: socialSecurityNum,
      municipality: city,
      company: {name: companyName, vatNumber: companyId, reference: companyRef},
      saveToCustomer: triggerSaveToCustomer, // to update customer object only when necessary
      isForeignCountryChecked: isCountryForeignChecked // used to update Safe Drive when entering info
    });
  };

  const customerValuesUpdate = () => {
    changeCustomer({
      address: address,
      company: isCompany,
      companyName: companyName,
      companyReference: companyRef,
      companyVatNumber: companyId,
      country: foreignCountry,
      dateOfBirth: isCustomerLoggedIn ? (customer?.dateOfBirth ?? user?.birthDate ?? user?.birthday) : dateOfBirth,
      // 2 user birth-dates --> '.birthdate' from /customers/me && '.birthday' from value physically typed by user (this helps differentiate)
      // above ternary: bugfix for dateOfBirth setting to '' directly after customer logins --> birthdate cannot be changed if logged in
      email: email,
      email2: email,
      emailConsent: "false",
      fairAccept: false,
      familyName: familyName,
      givenName: givenName,
      loggedIn: isCustomerLoggedIn,
      mayUseQuota: user?.mayUseQuota ?? false, // can set quota from user data if it exists, it shall not affect customer info components
      municipality: city,
      noBirthday: true,
      personalIdCode: socialSecurityNum,
      phoneNumber: phoneNumber,
      phoneNumber2: '',
      postalCode: zipCode,
      prepaid: prepaidNum,
      registeredForeigner: (isCustomerLoggedIn && isCountryForeign),
      secret: privateNum,
      unregisteredForeigner: (!isCustomerLoggedIn && isCountryForeign),
      relativeBankTransferDueDate: user?.relativeBankTransferDueDate,
      mayUseBankTransferAnytime: user?.mayUseBankTransferAnytime ?? false,
    })


  };

  useEffect(() => {
    // update submit button error string when all fields are completed without clicking submit
    let fieldErrorStrings = companyNameErrorString.length || companyIdErrorString.length || companyRefErrorString.length || givenNameErrorString.length ||
        familyNameErrorString.length || phoneNumberErrorString.length || reEnterPhoneErrorString.length || phoneNumberErrorString.length || reEnterPhoneErrorString.length ||
        reEnterPhoneErrorString.length || emailErrorString.length || reEnterEmailErrorString.length || dateOfBirthErrorString.length ||
        foreignCountryErrorString.length || addressErrorString.length || cityErrorString.length || zipCodeErrorString.length;

    if (fieldErrorStrings === 0 && submitValidationErrorString.length > 0) {
      setSubmitValidationErrorString('');
    }
  }, [companyNameErrorString, companyIdErrorString, companyRefErrorString, givenNameErrorString,
    familyNameErrorString, phoneNumberErrorString, reEnterPhoneErrorString,
    emailErrorString, reEnterEmailErrorString,
    dateOfBirthErrorString, foreignCountryErrorString, addressErrorString, cityErrorString,
    zipCodeErrorString])

  useEffect(() => {
    if(!firstRenderComplete) {
      UpdateUser(true, isCountryForeign);
      setFirstRenderComplete(true);
    } else { UpdateUser(false, isCountryForeign); }

    isFormUpdate.current = true;
    customerValuesUpdate();

  }, [givenName, familyName, socialSecurityNum, address, zipCode, email, foreignCountry,
    dateOfBirth, phoneNumber, companyName, companyRef, companyId, city]);

  useEffect(() => {
    // ensure we see customer form when we have customer info to show from existing customer
    if (closeNewCustomerInfo) {
      sessionStorage.removeItem('closeNewCustomerInfo');
      if (isCustomerLoggedIn) {
        // remove this trigger once logged in
        setCloseNewCustomerInfo(undefined);
        setShowCustomerForm(true);
      }
    } else if ((isCustomerLoggedIn || user?.id)) {
      setShowCustomerForm(true);
    }
  }, [isCustomerLoggedIn, user?.id, showCustomerForm]);

  const handleSubmit = async (e: any) => {
    setFormSubmitted(true);
    const checkValidationFields = () => {
      // uses the hook functions to check errors and return component names for autoscroll if err exists
      if(handleCompanyNameFieldErr()) { return handleCompanyNameFieldErr() }
      if(handleCompanyIdFieldErr()){ return handleCompanyIdFieldErr() }
      if(handleGivenNameFieldErr()) { return handleGivenNameFieldErr() }
      if(handleFamilyNameFieldErr()) { return handleFamilyNameFieldErr() }
      if(handleDateOfBirthFieldErr()) { return handleDateOfBirthFieldErr() }
      if(handleSSNFieldErr()) { return handleSSNFieldErr() }
      if(handleAddressFieldErr()) { return handleAddressFieldErr() }
      if(handleCityFieldErr()) { return handleCityFieldErr() }
      if(handleZipCodeFieldErr()) { return handleZipCodeFieldErr() }
      if(handleCountryFieldErr()) { return handleCountryFieldErr() }
      if(handlePhoneNumFieldErr()) { return handlePhoneNumFieldErr() }
      if(handleEmailFieldErr()) { return handleEmailFieldErr() }
      customerValuesUpdate();  // if no error, update and return
      return null
    }
    let fieldError = checkValidationFields();
    UpdateUser(true, isCountryForeign);
    if (fieldError) {
      if (appContext !== "production") {
        console.log("Some fields have not been completed correctly, first err field: ");
        console.log(fieldError);
      }
      setSubmitValidationErrorString(translateService.translate("vehicleSearch1.invalidSaveInfo"));

      // uses component name to auto scroll to error field
      let inputField = document.querySelector('[name="' + fieldError + '"]');
      inputField?.scrollIntoView({behavior: "smooth", block: "center"})
    } else {
      setSubmitValidationErrorString('');

      // Check business ID if company is selected and companyId exists
      let beCompanyName: string | undefined;
      if (isCompany && companyId && companyId.length > 0) {
        dispatch({
            type: 'SET_API_MESSAGE',
            payload: translateService.translate('vehicleSearch1.checkingBusinessId')
        })
        try {
          const response = await apiService?.user?.checkBusinessId(companyId);
          dispatch({
            type: 'SET_API_MESSAGE',
            payload: ''
          })

          if (response.status === 0) {
            setCompanyIdErrorString(translateService.translate('vehicleSearch1.companyVatIdNotValid'));
            dispatch({
              type: "SET_RESPONSE_MODAL",
              payload: translateService.translate("vehicleSearch1.invalidSaveInfo")
            });
            return;
          } else if (response.results?.name && response.results.name.length > 0 && (response.results.name !== companyName)) {
            // only replace with BE name if FE & BE are not identical
            beCompanyName = response.results.name;
            setCompanyName(response.results.name);
            dispatch({
              type: 'SET_API_MESSAGE',
              payload: translateService.translate('vehicleSearch1.companyValidated') + beCompanyName
            });
            await new Promise(resolve => setTimeout(resolve, 2000));
            dispatch({ type: 'SET_API_MESSAGE', payload: '' });
          }
        } catch (error) {
          if (appContext !== "production") console.log(error)
        }
      }

      handleSaveUser(beCompanyName).then(() => {}); // only performs save when validation is completed
    }
  }

  const handleSaveUser = async (beCompanyName?: string) => {
    if (apiService && user) {
      // TODO: re-enable reCaptcha when BE is ready
      // let reCaptchaToken: string | undefined;
      // if (executeRecaptcha) {
      //   reCaptchaToken = await executeRecaptcha('save_customer');
      // }
      let customerValues;
      let values: any = beCompanyName ? { ...customer, companyName: beCompanyName } : customer;

      let {registeredForeigner, noBirthday, mayUseQuota, phoneNumber2, mayUseBankTransferAnytime,
        loggedIn, dateOfBirth, personalIdCode, email2, unregisteredForeigner,
        fairAccept, ...customerValuesInitial } = values;

      if (unregisteredForeigner || registeredForeigner) { // Foreign customers
        customerValues = {
          ...customerValuesInitial,
          birthDate: dateOfBirth !== '' ? dateOfBirth : (user?.birthDate ?? user?.birthday ?? ''), // birth date value should never be empty hence fallback cases
          noPersonalIdCode: user?.smsLogin && user?.noPersonalIdCode !== undefined ? user?.noPersonalIdCode : true,
          emailConsent: false, // BE requires this for now - after fine tune --> remove
          personalIdCode: dateOfBirth !== '' ? dateOfBirth : (user?.birthDate ?? user?.birthday ?? ''),
          login: isCustomerLoggedIn,
          // remove white spaces from email and phone number:
          email: email.trim(),
          phoneNumber: phoneNumber.replace(/\s/g,''),
          rrmVersion: version
        }} else { // Finnish customers
        customerValues = {
          ...customerValuesInitial,
          birthDate: dateOfBirth !== '' ? dateOfBirth : (user?.birthDate ?? user?.birthday ?? ''),
          noPersonalIdCode: user?.smsLogin && user?.noPersonalIdCode !== undefined ? user?.noPersonalIdCode : false,
          emailConsent: false, // BE requires this for now - after fine tune --> remove
          personalIdCode: personalIdCode,
          login: isCustomerLoggedIn,
          email: email.trim(),
          phoneNumber: phoneNumber.replace(/\s/g,''),
          rrmVersion: version
        }
      }

      const userInfo = {...customerValues, language /* , reCaptchaToken */ }; // TODO: re-enable reCaptchaToken when BE is ready
      dispatch({
        type: 'SET_API_MESSAGE',
        payload: translateService.translate('vehicleSearch1.creatingCustomer'),
      });
      await apiService.user.saveUserDetails(userInfo).then((res) => {
        dispatch({type: 'SET_API_MESSAGE', payload: null});
        if (res.id) {
          next(values);
          changeUser({...user, id: res.id,
            ...(beCompanyName ? { company: { ...user?.company, name: beCompanyName } } : {})
          });
        }

        if ((window as any).ap3c){
          // add customer when we know the email and if ap3c func exists
          (window as any).ap3c.track({"v":0 ,"email": customer?.email ?? user?.email});
        }

      }).catch ((e) => {
        if (appContext !== "production") console.log(e)
        dispatch({
          type: "SET_RESPONSE_MODAL",
          payload: translateService.translate('profileCompletenessPhase.messages.savingFailed')
        });
        dispatch({type: 'SET_API_MESSAGE', payload: null});
        sendGa4Event("submit_customer_information", { customer_result: "failure"});
      });
    }
  }

  // @ts-ignore
  return <>
    { mobileDevice ?
        <>
          {(((!customer?.loggedIn || !user?.birthDate || user?.birthDate === '') || closeNewCustomerInfo)) && <>
            <div className={cx(styles.r24FullWidth, styles.noBorderAround, styles.r24BottomMargin10, "text-center")}>
              <div className={styles.returningcustomer}>
                <h2><Translate content={'vehicleSearch1.existingCustomer2'}/></h2>
              </div>
              <button className={cx("btn btn-cta w-75 m-auto", styles.orangeButton)}
                      id='existingCustomerLoginButton'
                      onClick={() => {
                        setShowLogin(true);
                        sendGa4Event("open_login");
                      }}>
                {translateService.translate('vehicleSearch1.login')}
              </button>
            </div>
          </> }

          { (!customer?.loggedIn) || closeNewCustomerInfo ?
              <>
                <div className={cx(styles.r24FullWidth, styles.noBorderAround, styles.r24BottomMargin10, "text-center")}>
                  <div className={styles.returningcustomer}>
                    <h2><Translate content={'vehicleSearch1.newCustomer2'}/></h2>
                  </div>
                  <div hidden={showCustomerForm}>
                    <button className={cx("btn btn-cta w-75 m-auto", styles.orangeButton)}
                            style={{backgroundColor: '#0BB395'}} // override orange button color without creating whole new class
                            onClick={() => {setShowCustomerForm(true)}} >
                      {translateService.translate('vehicleSearch1.continueAsGuest')}
                    </button>
                    <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
                  </div>


                </div>
              </> : null }
        </>
        :
        <>
          {(((!customer?.loggedIn || !user?.birthDate || user?.birthDate === '') || closeNewCustomerInfo)) &&
            <div className={cx(styles.r24FullWidth, styles.noBorderAround, "text-center")}>
              <div className={styles.returningcustomer}>
                <h2><Translate content={'vehicleSearch1.existingCustomer2'}/></h2>
              </div>
            </div> }

          { (!customer?.loggedIn) || closeNewCustomerInfo ?
                <div className={cx(styles.r24FullWidth, styles.noBorderAround, styles.r24BottomMargin10, "text-center")}>
                  <div >
                    <h3><Translate content={'vehicleSearch1.newCustomer2'}/></h3>
                  </div>
                </div>: null }

          <div className={cx(styles.r24FlexRow)}>
            {(((!customer?.loggedIn || !user?.birthDate || user?.birthDate === '') || closeNewCustomerInfo)) &&
                <div className={cx(styles.r24FullWidth, styles.noBorderAround, styles.r24BottomMargin10, "text-center")}>
                  <button className={cx("btn btn-cta font-weight-bold m-auto", styles.orangeButton)}
                          style={{width: showCustomerForm ? '50%' : '', height: !showCustomerForm ? '55px' : 'inherit'}}
                          id='existingCustomerLoginButton'
                          onClick={() => {
                            setShowLogin(true);
                            sendGa4Event("open_login");                            
                          }}>
                    {translateService.translate('vehicleSearch1.login')}
                  </button>
                </div>
              }

            { ((!customer?.loggedIn) || closeNewCustomerInfo) && !showCustomerForm ?
                <div className={cx(styles.r24FullWidth, styles.noBorderAround, styles.r24BottomMargin10, "text-center")}>
                    <button className={cx("btn btn-all btn-info font-weight-bold", styles.orangeButton)}
                            style={{backgroundColor: '#0BB395', height: '55px'}} // override orange button color without creating whole new class
                            onClick={() => {setShowCustomerForm(true)}}>
                      {translateService.translate('vehicleSearch1.continueAsGuest')}
                    </button>
                </div>
               : null }
          </div>
        </>
    }

    <div hidden={!showCustomerForm}>
      <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
      <CustomerCheckboxInput label={translateService.translate("vehicleSearch1.company")}
                             fieldName={"companyCheckField"}
                             formSubmitted={formSubmitted}
                             errorString={isCompanyErrorString} setValue={setIsCompany}
                             checked={isCompany}/>

      {isCompany &&
          <>
            <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopBottomMargin10)}>
              <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.companyName")}
                                 errorString={companyNameErrorString}
                                 value={companyName}
                                 fieldName={companyNameFieldRef}
                                 setValue={setCompanyName}
                                 formSubmitted={formSubmitted}
                                 className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
              />
              <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.companyID")}
                                 errorString={companyIdErrorString}
                                 value={companyId}
                                 fieldName={companyIdFieldRef}
                                 setValue={setCompanyId}
                                 formSubmitted={formSubmitted}
                                 className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
              />
            </div>
            <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.companyReference")}
                               errorString={companyRefErrorString}
                               value={companyRef}
                               formSubmitted={formSubmitted}
                               fieldName={"companyReferenceField"}
                               setValue={setCompanyRef}
                               className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
            />
          </>
      }

      <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
      <div className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>

        <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.name")}
                           errorString={givenNameErrorString}
                           value={givenName}
                           fieldName={givenNameFieldRef}
                           setValue={setGivenName}
                           formSubmitted={formSubmitted}
                           className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
        />

        <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.surname")}
                           errorString={familyNameErrorString}
                           value={familyName}
                           formSubmitted={formSubmitted}
                           fieldName={familyNameFieldRef}
                           setValue={setFamilyName}
                           className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
        />
      </div>
      {!customer?.loggedIn ?
          <CustomerCheckboxInput label={translateService.translate('vehicleSearch1.noHetu')} errorString={isCountryForeignErrorString}
                                 fieldName={"foreignCountryCheckField"}
                                 formSubmitted={formSubmitted}
                                 setValue={setIsCountryForeign}
                                 checked={isCountryForeign}
                                 onChangeAddAction={openSafeDriveInfo}/> : null
      }

      <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopBottomMargin10)}>
        {!customer?.loggedIn || !user?.birthDate || user?.birthDate !== '' ? // not logged in OR no birthdate
            isCountryForeign ? // get birthdate
                <>
                  <div onClick={() => setModalOpen(true)} className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}>
                    <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.birthDate")}
                                       errorString={dateOfBirthErrorString}
                                       value={isCustomerLoggedIn ? "xxxxxxxx" : dateOfBirth}
                                       setValue={() => {}}
                                       formSubmitted={formSubmitted}
                                       fieldName={dateOfBirthFieldRef}
                                       disableInput={isCustomerLoggedIn}
                                       className={cx(styles.r24ChildFlex1, styles.r24CustomerInfoRight, styles.vehicleSearch)} />
                  </div>
                  <BirthdayModalPicker
                      language={language} open={modalOpen}
                      onClose={() => setModalOpen(false)}
                      onContinue={(date: string) => {
                        setDateOfBirth(date);
                        setModalOpen(false);
                      }}
                      currentValue={dateOfBirth}
                  />
                </>

                : // Finish resident: social security no.
                <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.socialSecurity")}
                                   errorString={socialSecurityNumErrorString}
                                   value={isCustomerLoggedIn ? "xxxxxxxx-xxx" : socialSecurityNum}
                                   setValue={setSocialSecurityNum}
                                   fieldName={SSNFieldRef}
                                   formSubmitted={formSubmitted}
                                   disableInput={isCustomerLoggedIn}
                                   className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}

                />
            : // if birthdate is already set from profile
            <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.loginHetuText")}
                               errorString={socialSecurityNumErrorString}
                               value={isCustomerLoggedIn ? (user?.country ? "xxxxxxxx" : "xxxxxxxx-xxx") : socialSecurityNum}
                               setValue={setSocialSecurityNum}
                               formSubmitted={formSubmitted}
                               fieldName={SSNFieldRef}
                               disableInput={isCustomerLoggedIn}
                               className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
            />
        }
        <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.address")}
                           errorString={addressErrorString}
                           value={address}
                           fieldName={addressFieldRef}
                           formSubmitted={formSubmitted}
                           setValue={setAddress}
                           className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
        />
      </div>
      <div id="city{vehicle.id}" className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>
        <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.city")}
                           errorString={cityErrorString}
                           value={city}
                           formSubmitted={formSubmitted}
                           fieldName={cityFieldRef}
                           setValue={setCity}
                           className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
        />
        <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.postal")}
                           errorString={zipCodeErrorString}
                           value={zipCode}
                           formSubmitted={formSubmitted}
                           fieldName={zipCodeFieldRef}
                           setValue={setZipCode}
                           className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
        />
      </div>

      {(isCountryForeign || (user?.country === null && user?.noPersonalIdCode)) && // added case to look for loggedIn but country info missing
          <div className={'mr-md-1 mr-lg-1 mr-xl-1 mr-0'}>
            <CountrySelect errorString={foreignCountryErrorString} placeholder={translateService.translate("vehicleSearch1.country")}
                           userLanguage={language} value={foreignCountry} setValue={setForeignCountry}
                           fieldName={countryFieldRef}/>
          </div>
      }

      <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>

      <div className={cx(styles.r24FullWidth)}>
        {(!customer?.loggedIn && (!user?.birthDate || user?.birthDate !== '')) &&
            <>
              <div className={styles.phonenumber}><Translate content={'vehicleSearch1.phonenumberdescription1'}/></div>
              <div className={'w-100 flex-row d-flex m-0 p-0'}>
                <div className={'px-0 m-0'}>
                  <CustomerCheckboxInput label={translateService.translate("vehicleSearch1.secret")}
                                         errorString={''}
                                         formSubmitted={formSubmitted}
                                         fieldName={"secretNumField"}
                                         setValue={setPrivateNum}
                                         className={cx(styles.r24FullWidth, styles.r24PhoneNumber)}
                                         checked={privateNum}/>
                </div>
                <div className={'px-4 m-0'}>
                  <CustomerCheckboxInput label={translateService.translate("vehicleSearch1.prepaid")}
                                         errorString={''}
                                         formSubmitted={formSubmitted}
                                         fieldName={"prepaidNumField"}
                                         setValue={setPrepaidNum}
                                         className={cx(styles.r24FullWidth, styles.r24PhoneNumber)}
                                         checked={prepaidNum}/>
                </div>
              </div>
            </>
        }
      </div>

      { !customer?.loggedIn &&
          <div className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>
            <div className={styles.phonenumber}><Translate content={'vehicleSearch1.phonenumberdescription2'}/></div>
          </div>
      }

      <div >
        <div className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>
          <CustomerTextInput placeholder={translateService.translate("loginScreen.phoneNumber") + " *"}
                             errorString={phoneNumberErrorString}
                             value={phoneNumber}
                             fieldName={phoneNum1FieldRef}
                             setValue={setPhoneNumber}
                             formSubmitted={formSubmitted}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
                             disableInput={!!hideNumberForUrlLogin || (user?.smsLogin && (isCustomerLoggedIn || !!user?.id))}
                             preventSpaces={true}
          />

          {!hideNumberForUrlLogin && ((!customer?.loggedIn && !user?.id) || !user?.smsLogin) ?
              <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.phonerepeat") + " *"}
                                 errorString={reEnterPhoneErrorString}
                                 value={reEnterPhone}
                                 formSubmitted={formSubmitted}
                                 fieldName={phoneNum2FieldRef}
                                 setValue={setReEnterPhone}
                                 className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
                                 preventDropPaste={true}
                                 preventSpaces={true}
              /> : null
          }
        </div>
        { phoneNumberErrorString && saveInfoBtnClicked
          && phoneNumberErrorString === translateService.translate('vehicleSearch1.translationEnterDriverPhoneNotSame') ?
            <div className={cx(styles.r24BottomMargin10, styles.r24BtnToRight)}>
              <button className={cx("btn btn-cta btn-info w-50 px-4 mr-1")}
                      onClick={() => { 
                        back(1, 'additionalDriver');
                        sendGa4Event("navigate_back", { back_to: "to_additional_services" });
                      }}>
                {translateService.translate('vehicleSearch1.changeAddDriverNum')}
              </button>
            </div>
            : null
        }
        <div className={`${cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)} `}>
          <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.email") + " *"}
                             errorString={emailErrorString}
                             value={email}
                             formSubmitted={formSubmitted}
                             fieldName={email1FieldRef}
                             setValue={setEmail}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
                             preventSpaces={true}
          />

          <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.emailrepeat") + " *"}
                             errorString={reEnterEmailErrorString}
                             value={reEnterEmail}
                             formSubmitted={formSubmitted}
                             fieldName={email2FieldRef}
                             setValue={setReEnterEmail}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
                             preventDropPaste={true}
                             preventSpaces={true}
          />
        </div>
      </div>
      {saveInfoBtnClicked && <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>}
    </div>
    { saveInfoBtnClicked ?
        <div className={cx(styles.r24FullWidth, styles.r24FullWidthFlexPageSelection)} style={{alignItems: "center"}}>
          {/* This section is only for the submit error message to match + align it perfectly above the Save Information text*/}
          <div className={cx(styles.r24ChildFlex1, styles.r24RightMargin5)}></div>
          <div className={cx(styles.r24ChildFlex4, styles.r24LeftMargin5)}>
            <div className={cx(styles.r24FullWidthFlexPageSubmitError)}>{submitValidationErrorString}</div>
          </div>
        </div>
        : null
    }
    <div className={cx('d-flex min-width-320', styles.r24FullWidth, styles.r24Padding10, styles.r24FullWidthFlexPageSelection)} style={{alignItems: "center"}}>
          <div className={cx('flex-grow-1', styles.r24ChildFlex1, styles.r24RightMargin5)} scroll-to-item="true"
               scroll-to="#rentalStepsTop">
            <button type="button" className={cx("btn btn-all", styles.greenBackButton)} onClick={() => {back(); sendGa4Event("navigate_back", { back_to: "to_additional_services" }); }}>
              <ArrowBackIcon className={styles.arrowIcon}/>
            </button>
          </div>

          <div className={cx('flex-grow-1', styles.r24ChildFlex4, styles.r24LeftMargin5)} scroll-to-item="true"
               scroll-to="#rentalStepsTop">
            <button type="submit" className={cx("btn btn-cta float-right", styles.btn, (showCustomerForm ? styles.orangeButton :styles.grayButton))}
                    style={{verticalAlign: "top"}}
                    onClick={(e: any) => {setSaveInfoBtnClicked(true); handleSubmit(e)}} autoFocus disabled={!showCustomerForm}>
              {translateService.translate('vehicleSearch1.continueToPayment')}
            </button>
          </div>
        </div>
    {/* <ReCaptchaDisclaimer lang={language}/> */}{/* TODO: re-enable when BE reCaptcha is ready */}
  </>
}
